import {isDonationTicketDefinition} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {CloseSmall, DeleteSmall, SelectFill} from '@wix/wix-ui-icons-common/on-stage'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {IconButton} from 'wix-ui-tpa/cssVars'
import {useColors} from '../../../../../hooks/colors'
import {getPlaceInfoText, isPlaceInBasket} from '../../../../../selectors/seating/place'
import {WholeElementReservation} from '../whole-element-reservation'
import {CustomDatesLabel} from './custom-dates-label'
import {TicketInfoTexts} from './ticket-info-texts'
import {classes} from './ticket-info.st.css'
import {TicketInfoProps} from '.'

export const TicketInfo = ({
  place,
  showAccessibilityMode,
  inDrawer,
  onCloseClick,
  onRemoveClick,
  inPopover,
  basketView,
  inDescription,
  selected,
}: TicketInfoProps) => {
  const {t} = useTranslation()
  const {darkColor} = useColors()
  const showCustomDatesLabel = inDrawer || showAccessibilityMode || inPopover
  const inBasket = isPlaceInBasket(place)
  const isDonation = place.ticket ? isDonationTicketDefinition(place.ticket) : false
  const showCheckbox = inBasket && !selected && !basketView && !inPopover && !inDescription

  return (
    <div className={classes.container}>
      {showCheckbox ? (
        <SelectFill
          className={classNames(classes.checkbox, {
            [classes.checkboxFillWired]: darkColor,
            [classes.checkboxFillNotWired]: !darkColor,
          })}
        />
      ) : null}
      {onCloseClick ? (
        <IconButton
          data-hook={DH.CLOSE_DRAWER}
          className={classes.headerButton}
          icon={<CloseSmall />}
          onClick={onCloseClick}
        />
      ) : null}
      {onRemoveClick ? (
        <IconButton
          data-hook={DH.REMOVE_TICKET}
          className={classes.headerButton}
          icon={<DeleteSmall />}
          onClick={onRemoveClick}
          aria-label={`${t('seatings_removeFromBasket')} ${getPlaceInfoText(place, t)}`}
        />
      ) : null}
      {showCustomDatesLabel && <CustomDatesLabel place={place} />}
      <TicketInfoTexts place={place} inPopover={inPopover} inDescription={inDescription} inDrawer={inDrawer} />
      {(inPopover || inDrawer) && !isDonation ? (
        <WholeElementReservation place={place} basketView={false} inDescription={false} showAccessibilityMode={false} />
      ) : null}
    </div>
  )
}
